import { BaseResourceApiService } from '@shared/services/BaseResourceApiService';
import { ContactMethodFormatter } from '@pbx/services/formatter/ContactMethod';

class ContactServiceClass extends BaseResourceApiService {
  constructor(opts) {
    super(opts);
  }

  getTableList(params = {}) {
    return this.pure_http.get('/pbx/client/contacts', { params: params });
  }

  getSelect(params = {}) {
    return this.pure_http
      .get(`/pbx/client/select/contacts`, { params: params })
      .then(res =>
        res.map(item => ({
          ...item,
          contact_methods: ContactMethodFormatter.formatItems(item.contact_methods)
        }))
      )
      .then(res => res.filter(c => c.contact_methods.length > 0));
  }
}

export const ContactService = new ContactServiceClass({
  api_version: 2,
  resource: '/pbx/contacts'
});
